import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import Navbar from "@/components/Navbar";
import { Check, Loader2, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("pending");
  const [attempts, setAttempts] = useState(0);
  const { refresh } = useAuth();

  useEffect(() => {
    if (!sessionId) {
      navigate("/pricing");
      return;
    }
    if (status === "paid" || attempts > 15) return;
    const t = setTimeout(async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        setStatus(data.payment_status);
        setAttempts((a) => a + 1);
        if (data.payment_status === "paid") {
          await refresh();
        }
      } catch {
        setAttempts((a) => a + 1);
      }
    }, 2000);
    return () => clearTimeout(t);
  }, [sessionId, status, attempts, navigate, refresh]);

  return (
    <div className="min-h-screen bg-[#080A11] text-slate-100">
      <Navbar />
      <div className="max-w-xl mx-auto px-6 pt-40 text-center" data-testid="payment-success-container">
        {status === "paid" ? (
          <>
            <div className="w-16 h-16 rounded-2xl bg-emerald-500/20 border border-emerald-500/30 flex items-center justify-center mx-auto mb-6">
              <Check className="w-8 h-8 text-emerald-400" />
            </div>
            <h1 className="font-display text-4xl font-bold text-white mb-3">Paiement confirmé</h1>
            <p className="text-slate-400 mb-8">Votre abonnement est actif. Bienvenue chez RevenueFix AI !</p>
            <Button
              data-testid="payment-success-dashboard-btn"
              onClick={() => navigate("/dashboard")}
              className="bg-gradient-to-r from-violet-600 to-blue-600 border-0 h-12 px-8"
            >
              Aller au dashboard
            </Button>
          </>
        ) : attempts > 15 ? (
          <>
            <h1 className="font-display text-3xl font-bold text-white mb-3">Paiement en cours de traitement</h1>
            <p className="text-slate-400 mb-6">Nous mettons à jour votre compte. Rechargez la page dans quelques instants.</p>
            <Button onClick={() => navigate("/dashboard")} variant="outline">Voir le dashboard</Button>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-2xl bg-violet-500/20 border border-violet-500/30 flex items-center justify-center mx-auto mb-6 animate-pulse">
              <Sparkles className="w-8 h-8 text-violet-400" />
            </div>
            <h1 className="font-display text-3xl font-bold text-white mb-3">Confirmation du paiement...</h1>
            <p className="text-slate-400 mb-8 flex items-center justify-center gap-2">
              <Loader2 className="w-4 h-4 animate-spin" /> Vérification auprès de Stripe
            </p>
          </>
        )}
      </div>
    </div>
  );
}
